import { render, staticRenderFns } from "./liberacaoautomatica.vue?vue&type=template&id=08491895&scoped=true&"
import script from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
export * from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
import style0 from "./liberacaoautomatica.vue?vue&type=style&index=0&id=08491895&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08491895",
  null
  
)

export default component.exports